import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function CustomCursor() {
  const mouseX = useMotionValue(-100);
  const mouseY = useMotionValue(-100);
  const springX = useSpring(mouseX, { damping: 30, stiffness: 400, mass: 0.4 });
  const springY = useSpring(mouseY, { damping: 30, stiffness: 400, mass: 0.4 });

  const [variant, setVariant] = useState("default"); // default | play | link
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia("(pointer: coarse)").matches) return;

    const move = (e) => {
      mouseX.set(e.clientX);
      mouseY.set(e.clientY);
      setHidden(false);
    };
    const leave = () => setHidden(true);

    const over = (e) => {
      const t = e.target.closest("[data-cursor]");
      if (!t) {
        setVariant("default");
        return;
      }
      setVariant(t.getAttribute("data-cursor"));
    };

    window.addEventListener("mousemove", move);
    document.addEventListener("mouseleave", leave);
    document.addEventListener("mouseover", over);
    return () => {
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseleave", leave);
      document.removeEventListener("mouseover", over);
    };
  }, [mouseX, mouseY]);

  const size = variant === "play" ? 96 : variant === "link" ? 40 : 12;
  const label = variant === "play" ? "PLAY" : "";

  return (
    <motion.div
      aria-hidden
      className="pointer-events-none fixed left-0 top-0 z-[110] hidden md:flex items-center justify-center rounded-full text-[10px] tracking-[0.28em] font-body font-medium"
      style={{
        x: springX,
        y: springY,
        translateX: "-50%",
        translateY: "-50%",
        width: size,
        height: size,
        opacity: hidden ? 0 : 1,
        background:
          variant === "play" ? "#E63946" : variant === "link" ? "#F5F5F5" : "#F5F5F5",
        color: variant === "play" ? "#0a0a0a" : "#0a0a0a",
        mixBlendMode: variant === "default" ? "difference" : "normal",
        transition: "width 0.35s cubic-bezier(0.65,0,0.35,1), height 0.35s cubic-bezier(0.65,0,0.35,1), background 0.35s ease",
      }}
      data-testid="custom-cursor"
    >
      {label}
    </motion.div>
  );
}
